export class UserSettingsRegional {
  formats: string = "en-GB"
  lang: string = "en-US"
  ltformat: string = "HH:mm:ss"
  offset: number = 120
  reg: string = "Europe"
  stformat: string = "h:mm A"
  zone: string = "Europe/Amsterdam"
}
